import users from './users';
import candidates from './candidates';
import vacancies from './vacancies';
import recruiters from './recruiters';
import matches from './matches';
import login from './login';

function* rootSaga() {
  return yield [
    ...users(),
    ...matches(),
    ...candidates(),
    ...vacancies(),
    ...recruiters(),
    ...login()
  ];
}

export default rootSaga;



// WEBPACK FOOTER //
// ./src/sagas/index.js